import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#00A7FF',
    primaryLight: '#94CAFC',
    secondary: '#5BBFA5',
    mainGray: '#747B84',
    white: '#ffffff',
    black: '#000000',
  },
});